export default {
    lang: {
        name: 'Plays'
    }
}